import { css } from 'styled-components'

import type { INodeV2StyledProps } from './NodeV2Styled'

const FlexStyled = ({ $style }: INodeV2StyledProps) => css`
  display: flex;
  flex-wrap: ${$style?.flexWrap};

  flex-direction: ${$style?.flexDirection};
  gap: ${$style?.flexGap}px;

  align-items: ${$style?.flexAlignItems};
  justify-content: ${$style?.flexJustifyContent};
`

export default FlexStyled
